import dayjs from 'dayjs';

export const isBefore = (firstDate: string, secondDate: string): boolean => {
  if (!isNaN(Date.parse(firstDate)) && !isNaN(Date.parse(secondDate))) {
    return new Date(firstDate) < new Date(secondDate);
  }

  return false;
};

export const isLessThan6MonthSeniority = (
  startDate: string | Date,
  year?: number
): boolean => {
  return dayjs(startDate).isAfter(
    dayjs()
      .set('year', year ?? dayjs().year())
      .set('month', 6)
      .set('date', 1)
      .endOf('day')
  );
};

/**
 * Check if the given date is valid
 * @param date
 * @returns {Boolean}
 */
export function isValidDate(date: Date | string): boolean {
  const dateObject = new Date(date);

  return dateObject && !Number.isNaN(Date.parse(dateObject.toString()));
}

export function validDateOrNull(date: Date | string | null): Date | null {
  if (date === null) {
    return null;
  }

  if (isValidDate(date)) {
    return new Date(date);
  }

  return null;
}

/**
 * Will return the start of a day.
 * If the date is null, it will return the start of the current day.
 *
 * @param {Date | undefined} date
 * @returns {Date}
 */
export function startOfDay(date?: Date): Date {
  return date
    ? dayjs(date).startOf('day').toDate()
    : dayjs().startOf('day').toDate();
}

/**
 * Will return the end of a day.
 * If the date is null, it will return the end of the current day.
 *
 * @param {Date | undefined} date
 * @returns {Date}
 */
export function endOfDay(date?: Date): Date {
  return date
    ? dayjs(date).endOf('day').toDate()
    : dayjs().endOf('day').toDate();
}
